// src/services/tables/tableHelpers.js - SHARED TABLE HELPER FUNCTIONS

/**
 * Header tooltip mappings for table columns
 * Used by DynastyTable.js HeaderTooltip component
 */
export const headerTooltips = {
  // Hitter stats
  'G': 'Games Played',
  'AB': 'At Bats',
  'R': 'Runs Scored',
  'H': 'Hits',
  '2B': 'Doubles',
  '3B': 'Triples',
  'HR': 'Home Runs',
  'HR/AB': 'Home Run per At Bat Ratio',
  'RBI': 'Runs Batted In',
  'SB': 'Stolen Bases',
  'CS': 'Caught Stealing',
  'BB': 'Walks (Base on Balls)',
  'SO': 'Strikeouts',
  'AVG': 'Batting Average',
  'OBP': 'On-Base Percentage',
  'SLG': 'Slugging Percentage',
  'OPS': 'On-Base Plus Slugging',
  
  // Pitcher stats
  'GS': 'Games Started',
  'W': 'Wins',
  'L': 'Losses',
  'SV': 'Saves',
  'BS': 'Blown Saves',
  'HLD': 'Holds',
  'QS': 'Quality Starts',
  'IP': 'Innings Pitched',
  'ER': 'Earned Runs',
  'ERA': 'Earned Run Average',
  'WHIP': 'Walks + Hits per Inning Pitched',
  'K/9': 'Strikeouts per 9 Innings',
  'BB/9': 'Walks per 9 Innings',
  
  // General columns
  'Name': 'Player Name',
  'Team': 'MLB Team',
  'Pos': 'Position',
  'MLB Team': 'Major League Baseball Team',
  'Fantasy Team': 'Fantasy Team Owner',
  'Contract': 'Contract Length in Years',
  'Salary': 'Current Salary Amount',
  'Price': 'Free Agent Acquisition Price',
  'Action': 'Available Actions'
};